import React from 'react';

export const SEO = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "YFT Group",
    "alternateName": "Yellow Flower Trading",
    "url": "https://yftgroup.ae",
    "logo": "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/3b866mab_Screenshot%202025-11-26%20at%209.09.23%E2%80%AFAM.png",
    "description": "Four decades of family enterprise in the UAE. YFT Group is a Dubai-based conglomerate spanning retail, real estate, manufacturing, and salon services.",
    "foundingDate": "1987",
    "founders": [
      {
        "@type": "Person",
        "name": "Shyam Das Pagarani"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Dubai Textile City, Casco 7 - Al Awir Road - opposite Dragon Mart",
      "addressLocality": "Dubai International City",
      "addressRegion": "Dubai",
      "addressCountry": "AE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+971-50-123-4567",
      "contactType": "customer service",
      "email": "info@yftgroup.ae",
      "areaServed": "AE",
      "availableLanguage": ["en", "ar"]
    },
    "sameAs": [
      "https://www.linkedin.com/company/yellow-flower-trading/about/"
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "YFT Group",
    "image": "https://customer-assets.emergentagent.com/job_yftgroup/artifacts/3b866mab_Screenshot%202025-11-26%20at%209.09.23%E2%80%AFAM.png",
    "@id": "https://yftgroup.ae",
    "url": "https://yftgroup.ae",
    "telephone": "+971-50-123-4567",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Dubai Textile City, Casco 7 - Al Awir Road",
      "addressLocality": "Dubai",
      "addressRegion": "Dubai",
      "postalCode": "",
      "addressCountry": "AE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 25.1657,
      "longitude": 55.4113
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "08:00",
      "closes": "18:00"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://yftgroup.ae"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Legacy",
        "item": "https://yftgroup.ae#legacy"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Businesses",
        "item": "https://yftgroup.ae#businesses"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Leadership",
        "item": "https://yftgroup.ae#leadership"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Contact",
        "item": "https://yftgroup.ae#contact"
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </>
  );
};
